var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarReviewMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{stroke-width:0px;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#35986b;}.cls-5{fill:#cd642a;}.cls-6{fill:#aed2be;}.cls-7{fill:#d6e8dd;}.cls-8{fill:#f2bda5;}.cls-9{fill:#fff;}.cls-10{fill:#ea8f63;}.cls-11{fill:#002d1a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 48,
    height: 48,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -554.76,
    cy: -405.26,
    fx: -554.76,
    fy: -405.26,
    r: 1,
    gradientTransform: "translate(31404.05 17915.59) rotate(65.87) scale(52.6 -52.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#edf5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aed2be"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,8C0,3.58,3.58,0,8,0h32c4.42,0,8,3.58,8,8v32c0,4.42-3.58,8-8,8H8c-4.42,0-8-3.58-8-8V8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 30,
    cy: 72,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.57,65.04c-.08.14-.17.29-.26.44-3.16,5.28-7.36,11.34-12.91,17.54-3.37,3.76-6.72,7-9.89,9.76-1.2,1.05-2.92,1.27-4.35.54-4.05-2.08-8.42-4.63-12.95-7.75-3.67-2.53-6.97-5.12-9.93-7.68-3.91-3.37-7.24-6.69-10.03-9.74,4.39-3.96,8.78-7.93,13.17-11.89,2.23,1.84,4.49,3.68,6.8,5.52,4.43,3.54,8.83,6.94,13.17,10.19,0,0,.02-.01.03-.02,1.62-1.36,3.3-2.86,5.01-4.52,1.01-.98,2.02-2.01,3.03-3.1,5-5.36,12.43-16.14,12.43-16.14,2.33-2.05,6-.48,6.12,2.62.19,4.74.38,9.49.57,14.23h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m47.38,103.03c-13.17-.14-26.33-.28-39.5-.42-.28-18.41-.57-36.81-.85-55.22,2.03-.49,5.29-1.19,9.34-1.7,9.88-1.24,17.86-.48,26.76.42,3.07.31,7.46.83,12.74,1.7-2.83,18.41-5.66,36.81-8.5,55.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m11.64,93.47c-.54,5.17-1.09,10.33-1.64,15.5l2.55,2.55c-1.08,0-2.6-.09-4.31-.56-.66-.18-1.35-.41-2.06-.72-1.21-.52-2.19-1.13-2.97-1.7,1.23-11.09.73-20.05,0-26.33,0,0,.8-27.01.68-34.03-.02-.84,2.4-1.67,2.47-1.66.08,0,2.66-.55,2.68-.56.03,0,.19-.09.23-.11.4-.2.78-.41,1.15-.59.93-.47,2.16-.97,3.75-1.31.79-.17,1.66-.31,2.62-.39-1.12,11.05-2.25,22.09-3.4,33.13-.44,4.27-.89,8.55-1.34,12.82-.14,1.32-.28,2.64-.42,3.96h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m37.73,43.3c-1.48,1.4-3.92,3.33-7.38,4.62-1.71.64-3.29.98-4.61,1.16-1.17-.73-2.34-1.46-3.5-2.19-.73.58-1.46,1.17-2.19,1.75-2.91-.55-3.15-5.19-2.19-5.69,3.57-1.35,9.15-2.79,15.33-1.31,1.58.38,2.8.85,4.54,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.47,83.49c-.39,5.55-.81,12.57.42,21.66.41,3.01.9,5.49,1.27,7.22-2.87,1.01-6.85,2.08-11.68,2.43-5.34.38-9.81-.27-12.95-.97-.57-12.8-1.13-25.61-1.7-38.41.76-5.78,1.85-12.04,3.4-18.69,1.16-5,3.08-10.57,4.44-14.92,4.42.68,8.59,2.56,13.66,3.97,2.28.64,4.46,1.32,6.54,2.03-.96,8.04-2.36,20.91-3.4,35.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m34.5,42.08c-1.78,1.51-3.47,2.5-4.8,3.16-2.79,1.39-6.06,3.01-8.78,1.66-1.28-.64-2.05-1.74-2.51-2.61.02-.77.04-1.53.06-2.3l.13-5.06.05-2.1,9.42-9.79c1.13-1.18,3.13-.53,3.34,1.09,1.03,5.31,2.06,10.63,3.09,15.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.01,33.64c-.49,1.12-2.01,3.21-3.67,4.79-2.62,2.5-5.55,3.28-6.88,3.55l.13-5.06c.39-.2.63-.31.63-.31,3.06-.86,6.72-2.12,9.79-2.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m20.93,47.33s-1-.38-2-1.26c-.87-.77-1.74-1.93-1.94-3.56l.44-1.47,1.04-2.03c-.03.39-.02.94.17,1.55.43,1.4,1.49,2.16,1.85,2.39.15.41.28.89.38,1.42.22,1.18.16,2.2.05,2.96h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.63,42.29c-.91,1.1-4.37,5.03-9.79,5.41-1.51.1-2.84-.09-3.92-.36.52-.73,1.2-1.93,1.31-3.5.02-.31.02-.6,0-.88.32-.04.65-.08.97-.12,7.52-1,11.06-3.82,11.06-3.82.12,1.09.24,2.19.36,3.28h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m35.91,42.29c-1.89,2.01-3.71,3.14-5.1,3.82-2.28,1.11-5.58,2.06-5.68,2.1l-.28-.51-2.42-4.41-.18-.33c.33-.04.66-.07.97-.12,7.52-1,11.06-3.82,11.06-3.82.54,1.09,1.09,2.19,1.63,3.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m20.49,42.95l-.1.2-1.46,2.92-.63,1.26s-2.19-1.31-2.19-3.72l1.32-2.57,1.04-2.03s-.16,2.85,1.8,3.84c.07.04.14.07.22.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m35.18,17.46c-.3,2.93-1.93,6.14-4.56,8.02-.32.23-.65.43-.99.62-3.63,1.95-8.34,1.18-11.4-1-1.3-.93-2.3-2.12-2.79-3.46-.32-.87-.62-2.35,0-4.46-.26,0-2.26-.02-3.29-1.48-1.02-1.46-.31-3.27.04-4.2.47-1.26,1.37-2.47,2.54-3.32.9-.65,1.98-1.08,3.14-1.14,1.04-.06,1.9.19,2.43.41-2.27,1.88-2.81,2.36-2.84,2.43.06,0,1.04-.93,2.43-1.62.77-.38,3.2-1.59,6.08-.81,2.59.7,4.02,2.6,4.46,3.24,2.15.44,3.16,1.41,3.65,2.03.94,1.2,1.28,2.92,1.09,4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m35.18,17.46c-.3,2.93-1.93,6.14-4.56,8.02-3.26.62-7.82.3-12.39-.38-1.3-.93-2.3-2.12-2.79-3.46-.32-.87-.62-2.35,0-4.46-.26,0-2.26-.02-3.29-1.48-1.02-1.46-.31-3.27.04-4.2.47-1.26,1.37-2.47,2.54-3.32-.81,1.85-1.23,4.43,2.32,4.94,0,0,4.46-5.27,9.33-2.03,4.87,3.24,3.24,4.46,3.24,4.46,0,0,4.27-1.42,5.55,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m29.9,29.04c-.47,3.14-1.32,5.64-3.63,6.62-.19.08-1.09.93-1.27,1-1.85.64-3.2.82-3.88.8-.81-.02-1.92-.05-2.84-.41-3.55-1.36-4.25-7.52-4.46-9.33-.57-5.02.85-9.21,2.03-11.76-.07.4-.18,1.38.41,2.03.22.24.85.79,3.24.41,3.31-.53,4.33-2.11,6.89-2.03.11,0,.21,0,.32.02.74.06,1.34.25,1.71.39-.24,2.09.13,3.37.41,4.06.1.24.28.66.44.99.41.82.73,1.31,1.18,2.26.49,1.04-.15,2.38-.54,4.96h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m25.17,35.03c-.53.61-1.88,2.16-4.06,2.43-.13.02-1.49.11-2.84-.41-3.55-1.36-4.25-7.52-4.46-9.33-.57-5.02.85-9.21,2.03-11.76-.07.4-.18,1.38.41,2.03.22.24.85.79,3.24.41,3.31-.53,8.92-1.62,7.94,6.29-.47,3.78-.03,5.96-.64,7.5-.54,1.35-1.01,2.14-1.62,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m30.03,23.27s1.99-1.42,3.12-.69c.38.25.51.63.53.69.38,1.07.18,2.62-.49,3.37-.43.48-1.4,1.45-3.07,1.42-.03-1.6-.06-3.2-.09-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m13.68,24.78c.03,2.59.51,3.34.99,3.49.59.19,1.02-.58,2.55-.85.5-.09.54-.02,2.12,0,2.42.03,2.32-.13,2.97,0,1.77.36,2.02,1.44,2.97,1.27.96-.16,1.48-1.39,2.12-2.97.46-1.12,1.03-2.84,1.27-5.1l1.27,1.27s.68,11.06-1.87,13.18c-4.18,3.49-11.65,5.94-13.85,2.96-.69-.93-.75-2.47-.85-5.52-.1-3.19.08-5.85.28-7.74h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m30.65,10.43s.83-2.03,2.54-.67c0,0-1.05,1.18-2.54.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m21.39,45.58c-.5.41-1.2,1.05-1.93,1.93-.8.97-.93,1.23-.97,1.45-.1.59.15,1.04.97,2.42.61,1.03,1.12,1.87,1.45,2.42.5-.44,1.19-1.08,1.93-1.93,1.01-1.16,1.52-1.75,1.45-2.42-.06-.59-.48-.8-1.45-1.93-.66-.77-1.14-1.46-1.45-1.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.92,29.04c-2.2,0-3.58,1.78-2.68,2.68.9.9,4.84.78,5.44.36.6-.42-.55-3.04-2.76-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.22,25.45h-.02c-.09,0-.15-.09-.14-.18.1-.72.38-1.24.86-1.54.81-.51,1.85-.19,1.9-.17.08.03.13.12.1.2s-.12.13-.2.1c0,0-.95-.29-1.63.14-.39.25-.63.69-.71,1.32-.01.08-.08.14-.16.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m18.3,25.79h-.03c-.37-.06-.63-.25-.77-.56-.56-1.24,1.18-4.09,1.26-4.21.05-.07.14-.1.22-.05.07.05.1.14.05.22-.48.78-1.64,3.01-1.24,3.91.09.21.27.33.53.38.09.01.14.1.13.18,0,.08-.08.13-.16.13h.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarReviewMale);
export default __webpack_public_path__ + "static/media/Avatar_Review_Male.bd1545ab285b839891bdfc1e9f6645ea.svg";
export { ForwardRef as ReactComponent };